import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function VideoIcon({ className, width = 17, height = 17 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-400', className)}
            width={width}
            height={height}
            viewBox='0 0 17 17'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.12329 14.7758H4.82371C2.30913 14.7758 1.41663 13.012 1.41663 11.3687V5.6312C1.41663 3.18037 2.37288 2.22412 4.82371 2.22412H9.12329C11.5741 2.22412 12.5304 3.18037 12.5304 5.6312V11.3687C12.5304 13.8195 11.5741 14.7758 9.12329 14.7758ZM4.82371 3.30079C2.97496 3.30079 2.49329 3.78245 2.49329 5.6312V11.3687C2.49329 12.24 2.79788 13.6991 4.82371 13.6991H9.12329C10.972 13.6991 11.4537 13.2175 11.4537 11.3687V5.6312C11.4537 3.78245 10.972 3.30079 9.12329 3.30079H4.82371V3.30079Z'
                fill='currentColor'
            />
            <path
                d='M14.7191 12.828C14.4146 12.828 14.025 12.7288 13.5787 12.4172L11.6875 11.0926C11.5458 10.9934 11.4608 10.8305 11.4608 10.6534V6.34676C11.4608 6.16968 11.5458 6.00676 11.6875 5.9076L13.5787 4.58301C14.4216 3.9951 15.0379 4.1651 15.3283 4.31385C15.6187 4.46968 16.1146 4.87343 16.1146 5.90051V11.0926C16.1146 12.1197 15.6187 12.5305 15.3283 12.6793C15.1937 12.7572 14.9812 12.828 14.7191 12.828ZM12.5304 10.3701L14.195 11.5318C14.5137 11.7513 14.7404 11.7726 14.8325 11.723C14.9316 11.6734 15.0379 11.4751 15.0379 11.0926V5.9076C15.0379 5.51801 14.9246 5.32676 14.8325 5.27718C14.7404 5.2276 14.5137 5.24885 14.195 5.46843L12.5304 6.6301V10.3701Z'
                fill='currentColor'
            />
            <path
                d='M8.14587 8.32275C7.26754 8.32275 6.55212 7.60734 6.55212 6.729C6.55212 5.85067 7.26754 5.13525 8.14587 5.13525C9.02421 5.13525 9.73962 5.85067 9.73962 6.729C9.73962 7.60734 9.02421 8.32275 8.14587 8.32275ZM8.14587 6.19775C7.85546 6.19775 7.61462 6.43859 7.61462 6.729C7.61462 7.01942 7.85546 7.26025 8.14587 7.26025C8.43629 7.26025 8.67712 7.01942 8.67712 6.729C8.67712 6.43859 8.43629 6.19775 8.14587 6.19775Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default VideoIcon;

